// extracted by mini-css-extract-plugin
export const bannerLight = "banner-module--bannerLight--2mLP2";